const formataData=(data) =>{
    let year = data.substring(0, 4);
    let mouth = data.substring(5, 7);
    let day = data.substring(8, 10);
    let dataCompleta = day + "/" + mouth + "/" + year;
    return dataCompleta;
}

const converterDateToPadrao = (data) =>{
    let day = data.substring(0, 2);
    let mouth = data.substring(3, 5);
    let year = data.substring(6, 10);
    let date = mouth+"/"+day+"/"+year;
    return new Date(date);
}

const formataCategoria=(data)=> {
    let categoria;
    switch (data) {
        case 0:
            categoria = "Trabalhor do Comércio";
            break;
        case 1:
            categoria = "Dependente";
            break;
        default:
            categoria = "Público em Geral";
        break;
    }
    return categoria;
}

const formataNome=(data)=> {
    var arr = data.split(' ');
    if (arr[1].toString().length === 2) arr.splice(1, 1);
    return arr.slice(0, 2).join(' ');
}

const getFirstAndLastName=(data)=> {
    const nameParts = data.trim().split(" ");
    const firstName = nameParts[0];
    const lastName = nameParts[nameParts.length - 1];
    return `${firstName} ${lastName}`;
}

const colorBadge=(status)=>{
    let color;
    switch (status) {
        case 1:
            color = "teal";
            break;
        case 2:
            color = "yellow";
            break;
        case 4:
            color = "green";
            break;
        case 5:
            color = "red";
            break;
        case 6:
            color = "gray";
            break;
        default:
            color = "gray";
            break;
    }
    return color;
}

const statusString=(status)=>{
    let statusString;
    switch (status) {
        case 1:
            statusString = "Agendado";
            break;
        case 2:
            statusString = "Presente";
            break;
        case 4:
            statusString = "Atendido";
            break;
        case 5:
            statusString = "Cancelado";
            break;
        case 6:
            statusString = "Ausente";
            break;
        default:
            statusString = "";
            break;
    }
    return statusString;
}

const formatProcedimento=(str)=>{
        try{
            let arr = str.split(' ');
            if (arr[1].toString().length === 2) arr.splice(1, 1);
            return arr.slice(0, 1).join(' ');
        }catch{
            return str
        }
    }
    

export const ClienteF = {
    formataNome,
    colorBadge,
    formatProcedimento,
    statusString,
    formataCategoria,
    formataData,
    getFirstAndLastName,
    converterDateToPadrao
}